module.exports = __webpack_public_path__ + "balanced-portfolio-parsimonious-policy.cbaf920d624697e4861e0248849df596.svg";